import { view, lensPath } from 'ramda';

export const initialState = {};

export const getFilter = (state = initialState, name) => state[name] || {};
export const getFilterMiddleware = (state = initialState, name, middleware) =>
  view(lensPath([name, middleware]), state);



// WEBPACK FOOTER //
// ./src/store/filter/selectors.js